// start:ng42.barrel
export * from './IApplicationError';
export * from './IErrorTrace';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/ApplicationError/index.ts